import { EventType, PublicClientApplication } from '@azure/msal-browser';

import { msalConfig } from 'auth/msalConfig';

let instance: PublicClientApplication | null = null;
let initPromise: Promise<void> | null = null;

/**
 * Lazily constructs (and returns) the singleton MSAL instance. Construction is
 * deferred so importing this module does not require a browser crypto environment
 * (which keeps the module importable under jsdom/tests).
 */
export function getMsalInstance(): PublicClientApplication {
  if (!instance) {
    instance = new PublicClientApplication(msalConfig);
  }
  return instance;
}

/**
 * Initializes the MSAL instance exactly once. Safe to call repeatedly; subsequent
 * calls return the in-flight/settled promise.
 */
export function initializeMsalInstance(): Promise<void> {
  if (!initPromise) {
    const msal = getMsalInstance();
    initPromise = msal.initialize().then(async () => {
      msal.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_FAILURE) {
          // eslint-disable-next-line no-console
          console.error('MSAL login failure', event.error);
        }
      });
      // Process the auth-code redirect before the app routes (MSAL best practice).
      await msal.handleRedirectPromise();
    });
  }
  return initPromise;
}
